import React, { ReactNode, useState } from 'react';
import { Box, Button, Stack } from '@solvhealth/jigsaw';
import { useTranslation } from 'react-i18next';
import InsuranceProfileCard from '~/components/Paperwork/components/Payment/InsuranceProfileCard';
import { InsuranceProfile } from '~/components/Paperwork/hooks/useInsuranceProfiles';

type Props = {
  insuranceProfiles: InsuranceProfile[];
  handleInsuranceProfileSelect: (insurance_profile_id?: string) => void;
  selectedProfileId?: string;
  manualInsuranceInputs: ReactNode;
};

const InsuranceProfileCards = (props: Props) => {
  const { t } = useTranslation(['paperwork', 'common']);
  const {
    insuranceProfiles,
    handleInsuranceProfileSelect,
    selectedProfileId,
    manualInsuranceInputs,
  } = props;
  const [showAll, setShowAll] = useState(false);
  const visibleProfiles =
    insuranceProfiles.length > 2 && !showAll ? insuranceProfiles.slice(0, 2) : insuranceProfiles;

  const handleShowHideClick = (e: React.SyntheticEvent) => {
    setShowAll((prevState) => !prevState);
  };

  const handleCardClick = (profileId: string | undefined) => {
    if (profileId !== selectedProfileId) {
      handleInsuranceProfileSelect(profileId);
    } else {
      // the selected profile is being selected again so deselect it
      handleInsuranceProfileSelect(undefined);
    }
  };

  return (
    <Stack alignItems="center" pb={3} space={2}>
      {visibleProfiles?.map((profile) => {
        const isSelected = selectedProfileId === profile.insurance_profile_id;
        return (
          <Box key={`card-${profile.insurance_profile_id}`} width="100%">
            <InsuranceProfileCard
              handleInsuranceProfileSelect={handleCardClick}
              isSelected={isSelected}
              manualInsuranceInputs={manualInsuranceInputs}
              profile={profile}
            />
          </Box>
        );
      })}
      {insuranceProfiles.length > 2 && (
        <Button onClick={handleShowHideClick} type="button" variant="text">
          {showAll
            ? t(`paperwork:payment.hideMoreProfiles`)
            : t(`paperwork:payment.seeMoreProfiles`, {
                profileNumber: insuranceProfiles.length - 2,
              })}
        </Button>
      )}
    </Stack>
  );
};

export default InsuranceProfileCards;
